// src/module/format/bytes/index.ts
var BYTE_UNITS = ["bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
var BIBYTE_UNITS = ["bytes", "kiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
var BIT_UNITS = ["bits", "kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"];
var BIBIT_UNITS = ["bits", "kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"];
function formatBytes(number, options = {}) {
  options = { bits: false, binary: false, precision: 3, ...options };
  const UNITS = options.bits ? options.binary ? BIBIT_UNITS : BIT_UNITS : options.binary ? BIBYTE_UNITS : BYTE_UNITS;
  const isNegative = number < 0;
  const prefix = isNegative ? "-" : "";
  if (isNegative) {
    number = -number;
  }
  if (number < 1) {
    const unit2 = UNITS[0];
    return {
      prefix,
      number,
      unit: unit2,
      string: `${prefix}${number} ${unit2}`
    };
  }
  if (!options.exponent) {
    options.exponent = Math.min(
      Math.floor(options.binary ? Math.log(number) / Math.log(1024) : Math.log10(number) / 3),
      UNITS.length - 1
    );
  }
  number = Number((number / Math.pow(options.binary ? 1024 : 1e3, options.exponent)).toPrecision(options.precision));
  const unit = UNITS[options.exponent];
  return {
    prefix,
    number,
    unit,
    string: `${prefix}${number} ${unit}`
  };
}

export { formatBytes };
